<template>
  <svg
    role="img"
    aria-label="transcript icon"
    class="transcript-small-icon o-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
  >
    <title>Transcript Small</title>
    <path
      d="M12.3402 11.9399H4.26016C3.79016 11.9399 3.41016 11.5999 3.41016 11.1899C3.41016 10.7799 3.79016 10.4399 4.26016 10.4399H12.3502C12.8202 10.4399 13.2002 10.7799 13.2002 11.1899C13.2002 11.5999 12.8202 11.9399 12.3502 11.9399H12.3402Z"
      fill="currentColor"
    />
    <path
      d="M7.82016 8.09989L6.61016 5.09989C6.55016 4.94989 6.51016 4.82989 6.47016 4.73989C6.43016 4.63989 6.38016 4.54989 6.32016 4.45989C6.26016 4.36989 6.17016 4.28989 6.07016 4.22989C5.86016 4.10989 5.51016 4.10989 5.29016 4.22989C5.19016 4.28989 5.10016 4.36989 5.03016 4.45989C4.97016 4.54989 4.92016 4.65989 4.87016 4.78989L3.56016 8.11989C3.51016 8.23989 3.48016 8.33989 3.45016 8.40989C3.43016 8.48989 3.41016 8.56989 3.41016 8.63989C3.41016 8.77989 3.47016 8.90989 3.58016 9.02989C3.70016 9.13989 3.83016 9.18989 3.98016 9.18989C4.16016 9.18989 4.30016 9.12989 4.38016 9.01989C4.45016 8.92989 4.53016 8.75989 4.62016 8.51989L4.81016 7.99989H6.53016L6.72016 8.49989C6.75016 8.57989 6.79016 8.65989 6.83016 8.75989C6.88016 8.86989 6.92016 8.93989 6.96016 8.99989C7.01016 9.05989 7.07016 9.10989 7.14016 9.13989C7.21016 9.17989 7.29016 9.18989 7.39016 9.18989C7.55016 9.18989 7.69016 9.12989 7.80016 9.01989C7.91016 8.90989 7.97016 8.77989 7.97016 8.62989C7.97016 8.50989 7.92016 8.32989 7.82016 8.08989V8.09989ZM6.19016 7.05989H5.16016L5.67016 5.62989L6.19016 7.05989Z"
      fill="currentColor"
    />
    <path
      d="M13.1701 16H2.83008C1.31008 16 0.0800781 14.76 0.0800781 13.25V2.75C0.0800781 1.24 1.31008 0 2.83008 0H13.1701C14.6901 0 15.9201 1.24 15.9201 2.75V13.25C15.9201 14.77 14.6901 16 13.1701 16ZM2.83008 1.5C2.14008 1.5 1.58008 2.06 1.58008 2.75V13.25C1.58008 13.94 2.14008 14.5 2.83008 14.5H13.1701C13.8601 14.5 14.4201 13.94 14.4201 13.25V2.75C14.4201 2.06 13.8601 1.5 13.1701 1.5H2.83008Z"
      fill="currentColor"
    />
  </svg>
</template>

<style lang="scss" scoped>
.transcript-small-icon {
  height: 16px;
  width: 16px;
}
</style>
